import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { uploadParticipantFile } from '../../../api/s3';
import LinearProgress from '@material-ui/core/LinearProgress';
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0.5rem 1rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.common.silver}`,
    '&:hover': {
      backgroundColor: theme.palette.common.paleGrey,
    },
    '&:last-child': {
      borderBottom: `1px solid ${theme.palette.common.silver}`,
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  },
  widgets: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      width: '100%',
    },
  },
  iconButton: {
    marginLeft: '1rem',
    border: '1px solid transparent',
    '&:hover': {
      backgroundColor: 'transparent',
      border: `1px solid ${theme.palette.error.dark}`,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  cancelIcon: {
    color: theme.palette.error.dark,
  },
  successIcon: {
    color: theme.palette.common.tealish,
  },
  progress: {
    width: '10rem',
    height: '0.8rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '0.5rem 0',
    },
  },
}));

const FileUploadItem = ({file, removeFile, upload=false, onCompleted}) => {
  const classes = useStyles();
  const profile = useSelector(state => state.auth.profile);
  const [progress, setProgress] = useState(0);
  const [success, setSuccess] = useState(false);

  const uploadFile = async () => {
    await uploadParticipantFile(profile.user_uuid, file, setProgress, setSuccess);
  };

  useEffect(() => {
    if (upload) {
      uploadFile();
    }
  }, [upload]); // eslint-disable-line

  useEffect(() => {
    if (success) {
      onCompleted(file.name);
    }
  }, [success]); // eslint-disable-line

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2">
        {file.name}
      </Typography>
      <div className={classes.widgets}>
        <LinearProgress
          variant="determinate"
          color="secondary"
          value={progress}
          className={classes.progress}
        />
        {success ? (
          <IconButton disabled className={classes.iconButton}>
            <CheckIcon className={classes.successIcon} />
          </IconButton>
        ) : (
          <IconButton onClick={()=>removeFile(file.name)} className={classes.iconButton}>
            <CloseIcon className={classes.cancelIcon} />
          </IconButton>
        )}
      </div>
    </div>
  );
};

FileUploadItem.propTypes = {
  file: PropTypes.object.isRequired,
  removeFile: PropTypes.func.isRequired,
  upload: PropTypes.bool,
  onCompleted: PropTypes.func.isRequired,
};

export default FileUploadItem;
